import { FC, useEffect, useState } from 'react'
import Modal from '@common/Modal'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import iclasses from '@pages/Admin/CRM/styles/input.module.css'
import { IcoRemove } from '@/utils/icons'
import Button from '@UI/New/Button'
import cn from 'classnames'
import { useAddAlert } from '@/hooks/useAddAlert'
import { directionAPI, directionGroupApi } from '@/api'
import Preloader from '@UI/Preloader'
import { ElClassFormDataType } from '../PageContent/PageContent'
import Select from '@pages/Admin/CRM/components/base/Select/Select'

interface EditTeacherProps {
  group?: NonNullable<ElClassFormDataType['groups']>[number] | undefined
  open: boolean
  onClose: () => void
  onSuccess: (seminarian: {
    id: number
    name: string
    avatar_path: string
  }) => void
}

interface EditTeacherContentProps extends EditTeacherProps {}

const EditTeacherModalContent: FC<EditTeacherContentProps> = ({
  group,
  open,
  onClose,
  onSuccess,
}) => {
  const addAlert = useAddAlert()
  const [submitting, setSubmitting] = useState(false)
  const [loading, setLoading] = useState(false)

  const [teachers, setTeachers] = useState<any[]>([])

  useEffect(() => {
    if (group === null) {
      addAlert({
        title: 'Ошибка',
        text: 'Ошибка при получении списка педагогов',
        type: 'error',
      })
      onClose()
      return
    }

    setLoading(true)
    let arrOfTeacher: any[] = []
    directionAPI
      .getTeacherByDiraction({
        filter: [`[id][eq]=${group?.direction?.id}`],
        params: { expand: ['directionSeminarians.seminarian'] },
      })
      .then((res) => {
        res?.data?.data?.map((item: { directionSeminarians: any[] }) => {
          item?.directionSeminarians.forEach((item) => {
            if (
              !arrOfTeacher.find(
                (teacher) => teacher.value === item.seminarian.id,
              )
            ) {
              arrOfTeacher.push({
                label: item.seminarian.name,
                value: item.seminarian.id,
              })
            }
          })
        })

        setTeachers(arrOfTeacher)
      })
      .catch((err) => {
        addAlert({
          title: 'Ошибка',
          text: 'Ошибка при получении списка педагогов',
          type: 'error',
        })
      })
      .finally(() => {
        setLoading(false)
      })
  }, [group?.direction?.id])

  // forms

  const [data, setData] = useState<{
    teacher_id: number | null
  }>({ teacher_id: group?.seminarian?.id || null })

  const handlerData = (key: keyof typeof data, value: any) => {
    setData((prev) => ({ ...prev, [key]: value }))
  }

  const handlerSubmit = () => {
    if (data.teacher_id === null) {
      addAlert({
        type: 'error',
        title: 'Ошибка',
        text: 'Педагог не выбран',
      })
    }

    setSubmitting(true)
    directionGroupApi
      .updGroupTeacher({
        id: group?.id,
        teacher_id: data.teacher_id,
      })
      .then((res) => {
        if (
          res?.data?.teacher_id === undefined ||
          res?.data?.teacher_id === null
        )
          throw new Error()

        onSuccess && onSuccess({
          id: res.data.teacher_id,
          name: res.data.teacher_name,
          avatar_path: '',
        })
        addAlert({
          title: 'Успешно',
          text: `Педагог успешно изменен`, // в group?.name устаревшие данные
          type: 'success',
        })
        onClose()
      })
      .catch((err) => {
        addAlert({
          title: 'Ошибка',
          text: 'Ошибка при изменении педагога группы',
          type: 'error',
        })
        onClose()
      })
      .finally(() => {
        setSubmitting(false)
      })
  }

  return (
    <>
      <div className={cn(mclasses.modalContainer)}>
        <div className={mclasses.modalHeader}>
          <div className={mclasses.modalTitleContainer}>
            <span className={mclasses.modalHeaderTitle}>
              {group?.seminarian?.id
                ? 'Изменить педагога'
                : 'Выберите педагога группы'}
            </span>
          </div>
          <div className={mclasses.closeIcon} onClick={() => onClose()}>
            <IcoRemove />
          </div>
        </div>
        {loading ? (
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <Preloader fullScreen="app" />
          </div>
        ) : (
          <div className={cn(mclasses.formWrapper)}>
            <div>
              <p className={mclasses.label}>Педагог</p>
              <Select
                showSearch
                className={cn(iclasses.newSelect)}
                popupClassName={iclasses.newSelectPopup}
                placeholder="Выберите педагога"
                value={data.teacher_id ? Number(data.teacher_id) : null}
                onChange={(value) => handlerData('teacher_id', value)}
                options={teachers}
              />
            </div>
          </div>
        )}
        <div className={mclasses.actions}>
          <Button color="gray" onClick={() => onClose()}>
            Отменить
          </Button>
          <Button
            color="primary"
            onClick={handlerSubmit}
            disabled={submitting || loading}
            isLoading={submitting}
          >
            Подтвердить
          </Button>
        </div>
      </div>
    </>
  )
}

const EditTeacherModal: FC<EditTeacherProps> = (props) => {
  const { open, onClose } = props

  return (
    <>
      <Modal
        active={open}
        className={mclasses.modalWrapper as any}
        setActive={() => onClose()}
      >
        <EditTeacherModalContent {...props} />
      </Modal>
    </>
  )
}

export default EditTeacherModal
